<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/productPeriodList' }">产品期间</el-breadcrumb-item>
                <el-breadcrumb-item>产品期间{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <!-- 下拉 -->
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <!-- 下拉搜索 -->
                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                </el-form-item>

                                <!-- 日期 -->
                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <!-- 输入框 -->
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        :disabled="type == 'update' && item['prop'] == 'code'"
                                        clearable
                                    ></el-input>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <!-- 只读文本 -->
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, checkNumber, processColDataToEdit } from '@/js/common.js';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    name: 'productPeriodEdit',
    components: {
        vSearchSelect
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.type_code = 1;
            this.data.product_rid = this.$route.query.product_rid;
            this.initFormData();
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
            if (key == 'type_code') {
                this.resetTips();
            }
        },

        initFieldTypeMap() {
            this.fieldTypeMap = {
                product_rid: {
                    request_uri: 'dropdownProducts',
                    title: '产品',
                    ref: 'product_rid_ref',
                    display_name: 'name',
                    type: 'dropdown',
                    request_params: { type_code: [11, 15, 91] }
                },
                type_code: {
                    request_uri: 'dropdownProductPeriodType',
                    title: '类型',
                    ref: 'type_code_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                start_date: {
                    title: '开始日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'start_date_ref',
                    type: 'date',
                    tips: '不填，默认：2000-01-01'
                },
                end_date: {
                    title: '结束日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'end_date_ref',
                    type: 'date',
                    tips: '不填，默认：9999-12-31'
                },
                value: {
                    tips: '必填'
                },
                value1: {
                    tips: '无需填写'
                },
                value2: {
                    tips: '无需填写'
                }
            };
        },
        resetTips() {
            if (this.formData.type_code == 1) {
                this.fieldTypeMap.value.tips = '1-发货 2-欠缺 4-冗积，多选则累加';
                this.fieldTypeMap.value1.tips = '无需填写';
                this.fieldTypeMap.value2.tips = '无需填写';
            } else if (this.formData.type_code == 2) {
                this.fieldTypeMap.value.tips = '权重值';
                this.fieldTypeMap.value1.tips = 'A-重点 G-普通 O-订制 Q-消极 W-停滞 X-其他';
                this.fieldTypeMap.value2.tips = '0-不呈现 1-呈现 2-关注';
            } else if (this.formData.type_code == 3) {
                this.fieldTypeMap.value.tips = '产品系数';
                this.fieldTypeMap.value1.tips = '无需填写';
                this.fieldTypeMap.value2.tips = '无需填写';
            } else if (this.formData.type_code == 4) {
                this.fieldTypeMap.value.tips = '断货点';
                this.fieldTypeMap.value1.tips = '无需填写';
                this.fieldTypeMap.value2.tips = '无需填写';
            } else {
                this.fieldTypeMap.value.tips = '必填';
                this.fieldTypeMap.value1.tips = '无需填写';
                this.fieldTypeMap.value2.tips = '无需填写';
            }
        },
        initFormRule() {
            this.rules = {
                product_rid: [{ required: true, message: '请选择产品', trigger: 'blur' }],
                type_code: [{ required: true, message: '请选择类型', trigger: 'blur' }],
                start_date: [{ required: false, message: '请输入开始日期', trigger: 'blur' }],
                end_date: [{ required: false, message: '请输入结束日期', trigger: 'blur' }],
                value: [{ required: true, message: '请输入值', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.id = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                id: this.data.id || '0',
                product_rid: this.data.product_rid || '',
                type_code: this.data.type_code || 1,
                start_date: this.data.start_date || '',
                end_date: this.data.end_date || '',
                value: this.data.value || '',
                value1: this.data.value1 || '',
                value2: this.data.value2 || '',
                remark: this.data.remark || ''
            };
            this.resetTips();
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).product_period;

            processColDataToEdit(
                temp,
                this,
                {
                    white: ['value', 'value1', 'value2', 'remark', 'start_date', 'end_date']
                },
                {
                    product_name: 'product_rid',
                    type_code_label: 'type_code'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/productPeriodList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .productPeriodDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'productPeriodUpdate';
            } else {
                uri = 'productPeriodInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '保存成功！',
                            type: 'success'
                        });
                    }
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>